module.exports = __webpack_public_path__ + "static/media/image-search2.60ccb22d.gif";